<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Учёные степени лица (по отраслям науки):</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
              class="elevation-1  "
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{findNameObj('person',props.item.person)}}</td>
                <td class="justify-center">{{findNameObj('academicDegree',props.item.academicDegree)}}</td>
                <td class="justify-center">{{findNameObj('scientificIndustry',props.item.scientificIndustry)}}</td>
                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Person_academic_degree @addItem="addItem"
                @ended="closedForm"
                @refreshItem="refreshItem"
                v-bind="selected"
                v-if="opened_form"
      >
      </Person_academic_degree>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить учёные степени лица?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import Person_academic_degree from "../forms/Person_academic_degree"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "ListPerson_academic_degree",
        components: {Person_academic_degree},
        mixins: [UserDataMixin],

        data: function () {
            return {
                URL_LIST: urls.getUrl('admin|core|models|person_academic_degree-list', 'list'),
                URL_DELETE: urls.getUrl('admin|core|models|person_academic_degree-detail', 'destroy'),

                selectors:{
                    academicDegree:[],
                    person:[],
                  scientificIndustry:[]
                },
                headers: [
                  {
                  text: 'Пользователи', sortable: false, align: 'justify-center',
                  // class: 'headline'
                },
                    {
                        text: 'учёные степени лица',
                        align: 'justify-center',
                        sortable: false,
                    },

                    {
                        text: 'Отрасль науки ', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ],

            }
        },
        methods: {
            addItem(){
                this.closedForm()
                this.getItems();
            },
            load: function (app, url) {
                if (url === null) {
                    app.loadingPage = true;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors.person.push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url);
                    });
            },
            findNameObj(edit,id){
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                }else{
                    return ""
                }
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
        },
        created() {
            let url = urls.getUrl('admin|core|selectors|scientific_industry', 'get')
            this.loadSelector("scientificIndustry",url)

            url = urls.getUrl('admin|core|selectors|academic_degree', 'get')
            this.loadSelector("academicDegree",url)

            url = urls.getUrl('admin|core|selectors|person', 'get')
            this.load(this, url)

            this.getItems();
            this.$store.commit('mainpage/changeTitle', 'Учёные степени лица (по отраслям науки)');
        },
    }


</script>
<style scoped>

</style>
